module.exports = __webpack_public_path__ + "img/green_002.ebeee01b.png";